import * as L from 'leaflet';

export interface MarkerResult {
  uid: number;
  category: number;

  latitude: string;
  longitude: string;

  html: string;
}

export class AddressMarker extends L.Marker {
  uid: number;
  category: number;
  html: string;

  constructor(latLng: L.LatLngExpression, uid: number, category: number, html: string, options?: L.MarkerOptions) {
    super(latLng, options);
    this.uid = uid;
    this.category = category;
    this.html = html;
  }

  getUid() {
    return this.uid;
  }

  setUid(uid: number) {
    this.uid = uid;
  }

  getCategory() {
    return this.category;
  }

  setCategory(category: number) {
    this.category = category;
  }
}
